import React from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import Motion from "framer-motion";
import "../CSS/Portfolio.css";
import doubleArrow from "../Resources/Images/DoubleArraw.svg";
import developer from "../Resources/Images/Developercreatordesigner.svg";
import eclips from "../Resources/Images/Ellipse 1.svg";
import react from "../Resources/Images/React.svg";
import spring from "../Resources/Images/Spring.svg";
import java from "../Resources/Images/Java.svg";
import python from "../Resources/Images/Python.png";
import figma from "../Resources/Images/Figma.svg";
import photoshop from "../Resources/Images/Photoshop.svg";
import canva from "../Resources/Images/Canva.svg";
import capcut from "../Resources/Images/Capcut.svg";
import evertea from "../Resources/Images/EverTea.png";
import everteaWeb from "../Resources/Images/EverTeaWeb.png";
import ticketingSystem from "../Resources/Images/TicketingSystem.png";
import zain from "../Resources/Images/ZainBillBoard.png";


//Links


const Portfolio: React.FC = () => {
  return (
    <div className="htmlOverflow">
      <section className="hero">
        <div className="heroSection">
          <p className="mainTopic">Designing <br></br>Digital futures</p>
          <p className="subTopic">Bringing Visions to Life
            Building the Future, One Creation at a Time
            Innovating for Tomorrow, Today
            Crafting the Digital World with Creativity and Precision
          </p>
          <div className="contactMeShortCut">
            
            <img src={doubleArrow} alt="Arrows" />
            <Link to="/contact">Get Started</Link>
            
          </div>
        </div>
      </section>

      <section className="about">
        <div className="boarderCenter">
          <p className="aboutTopic">About Gerald Fernand0</p>
          <div className="aboutParagraph">
            <p>
              I am <span className="highlight">Gerald Fernando</span>, a passionate <span className="highlight">developer</span> and <span className="highlight">designer</span> who thrives at the intersection of technology and creativity. With a strong foundation in <strong>web</strong>,<strong>software development</strong>, <strong>UI/UX design</strong>, and <strong>multimedia production</strong>, I bring a <span className="highlight">unique</span> blend of <span className="aboutMeContentHighlight">functionality and aesthetics</span> to every project I work on.
            </p>
          </div>
          <div className="contactMeShortCut">
            <img src={doubleArrow} alt="Arrows" />
            <Link to="/about">About Me</Link>
          </div>
        </div>
      </section>

      <section className="services">
        <div className="servicesboarderCenter">
          <div className="serviceTopic">
            <p className="servicesTopic">
              Services that <span className="TopicHighlight"><br />are tailored</span>
            </p>
          </div>
          <div className="contactMeShortCut">
            <img src={doubleArrow} alt="Arrows" />
            <p>Services</p>
          </div>
        </div>
      </section>
      <section className="services">
        <div className="CardBoarderCenter">
          <div className="cardContainer">
            <p className="cardNumber">01</p>
            <h2 className="cardTitle">Web/Software Development</h2>
            <div className="tagContainer">
              <span className="tag">Development</span>
              <span className="tag">Brand Guidelines</span>
              <span className="tag">Analysis</span>
              <span className="tag">Rebranding Services</span>
            </div>
            <button className="plusButton">+</button>
          </div>
          <div className="cardContainer">
            <p className="cardNumber">02</p>
            <h2 className="cardTitle">UI/UX <br></br>Design</h2>
            <div className="tagContainer">
              <span className="tag">Development</span>
              <span className="tag">Brand Guidelines</span>
              <span className="tag">Analysis</span>
              <span className="tag">Rebranding Services</span>
            </div>
            <button className="plusButton">+</button>
          </div>
          <div className="cardContainer">
            <p className="cardNumber">03</p>
            <h2 className="cardTitle">Graphics <br></br>Design</h2>
            <div className="tagContainer">
              <span className="tag">Development</span>
              <span className="tag">Brand Guidelines</span>
              <span className="tag">Analysis</span>
              <span className="tag">Rebranding Services</span>
            </div>
            <button className="plusButton">+</button>
          </div>
        </div>
      </section>
      <section className="laguages">
        <div className="laguagesboarderCenter">
          <div className="laguagesTopic">
            <p className="laguageTopic">
              Languages <span className="TopicHighlight"><br />showcase</span>
            </p>
          </div>
        </div>
        <div className="languagesParagraph">
          <div className="languagesParagraphSecond">
            <p className="highlightLanguages">SpringBoot</p>
            <p className="highlightLanguages">React</p>
            <p className="highlightLanguages">ReactNative</p>
            <p className="highlightLanguages">Java</p>
            <p className="highlightLanguages">JavaScript</p>
          </div>
        </div>
      </section>
      <section className="creative">
        <div className="creativeboarderCenter">
          <div className="creativesTopic">
            <p className="creativeTopic">
              Creative <span className="TopicHighlight"><br />showcase</span>
            </p>
          </div>
          <div className="contactMeShortCut">
            <img src={doubleArrow} alt="Arrows" />
            <Link to="/about">Creativity</Link>
          </div>
        </div>
      </section>
      <section className="creative">
          <div className="selectedWorksList">
              <div className="selectedWorksListText">
                <a href="https://www.evertea.net/" target="_blank"><img className="selectedWorksIMG" src={everteaWeb} alt="Evertea" /></a>
                <p>EverTea <span className="selectedWorksListTextSpan">Marketing</span> <span className="selectedWorksListTextSpan">Web Development</span></p>
              </div>
              <div className="selectedWorksListText">
                <a href="https://github.com/ReidenRealm/w2052113-Cw-Tickets-Booking-App.git" target="_blank"><img className="selectedWorksIMG" src={ticketingSystem} alt="TicketingSystem" /></a>
                <p>Realtime Ticketing System <span className="selectedWorksListTextSpan">Booking</span> <span className="selectedWorksListTextSpan">Software Development</span></p>
              </div>
        </div>
      </section>

    </div>
  );
};

export default Portfolio;
